import { useState } from 'react';

const TagInput = ({ data, setData, touch, errors, name, label, id }) => {
    const [inputValue, setInputValue] = useState('');
    const hasError = (touch[name] && errors[name]) ? true : false

    const addTag = () => {
        if (inputValue.trim() !== '') {
            setData(prev => {
                return {
                    ...prev,
                    [name]: [...data[name], inputValue.trim()]
                }
            })
            setInputValue('');
        }
    };

    const removeTag = (indexToRemove) => {
        setData(prev => {
            const newTags = data[name].filter((_, index) => index !== indexToRemove);
            return {
                ...prev, [name]: newTags
            }
        })
    };
    const handleKeyDown = (evt) => {
        if (evt.key === 'Tab' || evt.key === 'Enter') {
            evt.preventDefault();
            addTag()
        }
    }

    return (
        <>
            <div className="w-full">
                <div className="relative flex items-center gap-3">
                    <input
                        type="text"
                        className={`${hasError ? 'border-red-500' : ''} flex-grow p-2 block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer`}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)} onKeyDown={handleKeyDown}
                        id={`outlined_${id}`} placeholder=""
                    />
                    <button
                        onClick={addTag}
                        type='button'
                        className="bg-blue-500 text-white rounded hover:bg-blue-600">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path></svg>
                    </button>
                    <label htmlFor={`outlined_${id}`} className={`${hasError ? 'text-red-500' : ''} absolute rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>{label}</label>
                </div>
                <div className="flex flex-wrap items-center mt-4 gap-2" dir='auto'>
                    {data[name]?.map((tag, index) => (
                        <div key={index} className="inline-flex items-center bg-gray-200 text-gray-800 text-sm font-medium rounded px-2 py-1">
                            {tag}
                            <button
                                onClick={() => removeTag(index)} type='button'
                                className="text-red-500 hover:text-red-700"
                            >
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path></svg>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            {hasError && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors[name]}</p>}
        </>
    );
};

export default TagInput;